import Warning from "../../src/assets/svg/warning.svg";

export interface ConditionsProps {
  requiredName: string;
  selected?: string[];
  onChange?: (values: string[]) => void;
  setErrors: React.Dispatch<React.SetStateAction<string[]>>;
  errors?: string[];
  inputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>;
}

export function Conditions(props: ConditionsProps) {
  const {
    requiredName,
    selected = [],
    onChange,
    setErrors,
    errors,
    inputRefs,
  } = props;

  const isError = errors && errors.includes(requiredName);

  const handleSelect = (value: string) => {
    let updatedSelection = [...selected];
    if (updatedSelection.includes(value)) {
      updatedSelection = updatedSelection.filter((item) => item !== value); // Deselect

      // If "consent" deselected, add error
      if (value === requiredName) {
        setErrors((prevErrors) => [...prevErrors, requiredName]);
      }
    } else {
      updatedSelection.push(value); // Select

      // If "consent" selected, remove error
      if (value === requiredName) {
        setErrors((prevErrors) =>
          prevErrors.filter((error) => error !== requiredName)
        );
      }
    }

    if (onChange) {
      onChange(updatedSelection);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          <label className="flex items-start gap-3 cursor-pointer hover:bg-gray-100">
            <input
              id="newsletter"
              type="checkbox"
              checked={selected.includes("newsletter")}
              onChange={() => handleSelect("newsletter")}
              className="flex gap-2.5 mt-1 form-checkbox text-primary-blue"
            />
            <span className="flex gap-1 text-[15px] text-gray-extra-dark opacity-90">
              Također želim od tvrtke C Automobil Import doo primati i druge
              informacije o novostima, pogodnostima, akcijama, događanjima i
              ponudama vezanim uz marku Citroën putem navedenih komunikacijskih
              kanala.
            </span>
          </label>
          <label className="flex items-start gap-3 cursor-pointer hover:bg-gray-100">
            <input
              id="analyticsConsent"
              type="checkbox"
              checked={selected.includes("analyticsConsent")}
              onChange={() => handleSelect("analyticsConsent")}
              className="flex gap-2.5 mt-1 form-checkbox text-primary-blue"
            />
            <span className="flex gap-1 text-[15px] text-gray-extra-dark opacity-90">
              Suglasan sam da se moji podaci analiziraju u svrhu pripreme i
              slanja personaliziranih ponuda, obavijesti, promocija, događanja,
              pogodnosti te u svrhu provođenja istraživanja tržišta.
            </span>
          </label>
        </div>
      </div>
      <hr className="w-full border-t-1 border-extra-light" />

      <div className="flex gap-3">
        <label className="flex items-start gap-3 cursor-pointer hover:bg-gray-100">
          <input
            ref={(el) => (inputRefs.current[requiredName] = el)}
            id={requiredName}
            type="checkbox"
            checked={selected.includes(requiredName)}
            onChange={() => handleSelect(requiredName)}
            className="mt-1 form-checkbox text-primary-blue"
            required={true}
          />
          <span className="text-[15px] text-gray-extra-dark opacity-90">
            Potvrđujem da sam upoznat s&nbsp;
            <a
              href="https://www.citroen.hr/korisne-informacije/izjava-o-privatnosti.html"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-primary-black"
            >
              Izjavom o zaštiti osobnih podataka
            </a>
            &nbsp;te da će u svrhu obrade zahtjeva koji sam naveo na ovom
            obrascu mojim osobnim podacima upravljati tvrtka C Automobil Import
            doo i odabrani ovlašteni prodavatelj/ serviser. Bez osobnih podataka
            označenih kao obvezni, tvrtka može osigurati adekvatnu obradu Vašeg
            zahtjeva. Upoznat sam da dajem privolu za obradu osobnih podataka u
            rubrici "OSTANIMO U KONTAKTU" s tvrtkom C Automobil Import doo.
            Svoju suglasnost mogu povući u bilo kojem trenutku.
            <span className="pl-1 text-sm text-warning-red">*</span>
            {isError && (
              <div className="flex items-center gap-1 text-sm text-warning-red">
                <img src={Warning} alt="Warning" />
                Ovo polje je obavezno.
              </div>
            )}
          </span>
        </label>
      </div>
    </>
  );
}

export default Conditions;
